// Smooth scroll to posts filter.
let params = new URLSearchParams(window.location.search);
let category = params.get("category");

if (category !== null) {
	scrollToPostsAnchor("#posts-filter-anchor");
}

function scrollToPostsAnchor(anchor) {
	requestAnimationFrame(() => {
		const loop = setInterval(() => {
			const target = document.querySelector(anchor);
			if (target) {
				clearInterval(loop);
				let headerHeight = document.querySelector("#masthead").clientHeight;

				target.style.top = `-${headerHeight + 20}px`;
				target.scrollIntoView({
					behavior: "smooth",
				});
			}
		}, 300);
	});
}
